export const COACH_PEBBLE_ROLE_CUSTOM_CLAIM = 'coachPebbleRole';
